import { updateAnalyticsTaskAttributeMetric } from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticTaskMetricProps = {
    metric?: number;
}

export const changeAnalyticsTaskAttributeMetric = ({
    metric,
}: AnalyticTaskMetricProps) => updateAnalyticsTaskAttributeMetric({
    metric,
});
